import {style} from './style';
import {LitElement, html} from "lit-element";
import {icon} from '@fortawesome/fontawesome-svg-core';

class swIcon extends LitElement {

    constructor() {
        super();
        this.set = 'fas';
    }

    static get styles() {
        return [
            style
        ];
    }

    static get properties() {
        return {
            icon: String,
            set: String
        };
    }

    render() {
        const iconElm = icon({prefix: this.set, iconName: this.icon});
        if(!iconElm){
            const importName = this.set === 'fas' ? '@fortawesome/free-solid-svg-icons' : '@fortawesome/free-regular-svg-icons';
            const iconName = 'fa'+this.icon.charAt(0).toUpperCase() + this.icon.slice(1);
            console.error('import '+iconName+' from '+importName+', then add the icon <'+iconName+'> to your project with library.add('+iconName+')');
            return html``;
        }
        return html`
            ${iconElm.node}
        `;
    }

    shouldUpdate(_changedProperties) {
        return !!this.icon && !!this.set;
    }
}

window.customElements.define("sw-icon", swIcon);
